import React from 'react';

import { useLocalTranslation } from '../../../common/hooks/useLocalTranslation';

interface PublicSurveyProgressProps {
  current: number;
  total: number;
  currentLanguage?: string;
}

export const PublicSurveyProgress: React.FC<PublicSurveyProgressProps> = ({
  current,
  total,
  currentLanguage,
}) => {
  const { t, tk } = useLocalTranslation('administrationLng', currentLanguage);
  const progress = ((current + 1) / total) * 100;

  return (
    <div className="public-survey-progress-container">
      <div className="public-survey-progress-header d-flex justify-content-between align-items-center mb-2">
        <span className="public-survey-progress-label text-muted">
          {t(tk.publicSurvey.question, { current: current + 1, total })}
        </span>
        <span className="public-survey-progress-percentage">
          {Math.round(progress)}%
        </span>
      </div>
      <div className="public-survey-progress-bar">
        <div
          className="public-survey-progress-fill"
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
};
